import { type UseQueryOptions, useQuery } from "@tanstack/react-query";
import { userQueryKeys } from "@/hooks/userQueryKeys";
import { usersApi } from "@/lib/humhub-api/users";

type BlockedUsersQueryKey = ReturnType<typeof userQueryKeys.blocked>;

type BlockedUsersQueryOptions = Omit<
  UseQueryOptions<string[], Error, string[], BlockedUsersQueryKey>,
  "queryKey" | "queryFn"
>;

export const useBlockedUsersList = (options?: BlockedUsersQueryOptions) => {
  return useQuery<string[], Error, string[], BlockedUsersQueryKey>({
    queryKey: userQueryKeys.blocked(),
    queryFn: usersApi.blockedUsersList,
    ...options,
  });
};
